(function () {
  document.addEventListener("DOMContentLoaded", function () {

    const wrapper = document.querySelector(".phone-wrapper");
    const overlay = document.querySelector(".phone-overlay");
    const modal = document.querySelector(".phone-modal");

    if (!wrapper || !overlay || !modal) return;

    // SHOW
    wrapper.addEventListener("mouseenter", () => {
      overlay.style.visibility = "visible";
      modal.style.visibility = "visible";

      requestAnimationFrame(() => { 
        overlay.style.opacity = "1";
        modal.style.opacity = "1";
        modal.style.transform = "scale(1)";
        
        const ariaExpanded = modal.getAttribute('aria-expanded');

        if (ariaExpanded === 'true') {
            return;
        } else {
            modal.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // HIDE
    wrapper.addEventListener("mouseleave", () => {
      overlay.style.opacity = "0";
      modal.style.opacity = "0";
      modal.style.transform = "scale(0.8)";
    
      const ariaExpanded = modal.getAttribute('aria-expanded');

        if (ariaExpanded === 'true') {
            modal.setAttribute('aria-expanded', 'false');
        } else {
            return;
        }
      setTimeout(() => {
        overlay.style.visibility = "hidden";
        modal.style.visibility = "hidden";
      }, 300);
    });

  });
})();